import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { USER_PATHS } from '../user/user';
import { AUTH_PATHS } from './auth';
import { MAIN_PATHS } from '../main/main';
import { PAGES_SERVICES_PATHS } from '../pages-services/pages-services';
import { isLegacyLoginEnabled } from '../../../environments/legacy-login';

export interface ActivateAuth {
  auth: boolean;
  expiriesPassword: boolean;
  redirect: any;
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private changePasswordPage = ['/' + USER_PATHS.change_password_auth_user];
  private authPage = ['/' + (isLegacyLoginEnabled() ? AUTH_PATHS.login_legacy : AUTH_PATHS.login)];
  private mainPage = [MAIN_PATHS.main];
  private accessDenied = ['/' + PAGES_SERVICES_PATHS.access_denied];

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.authService.isLoggedIn()) {
        if (this.authService.checkExpiriesPassword()) {
          this.redirectToChangePasswordPage(next);
          resolve(true);
        } else {
          if (this.checkRouteAccess(next)) {
            resolve(true);
          } else {
            this.redirectToPermissionDeniedPage(next, state);
            resolve(false);
          }
        }
      } else {
        this.authService
          .checkAuth()
          .then((response: ActivateAuth) => {
            if (response.auth && response.expiriesPassword) {
              this.redirectToChangePasswordPage(next);
              resolve(true);
            } else {
              if (this.checkRouteAccess(next)) {
                resolve(true);
              } else if (this.router.url.indexOf('/auth/login') > -1) {
                this.redirectToMainPage();
                resolve(true);
              } else {
                this.redirectToPermissionDeniedPage(next, state);
                resolve(false);
              }
            }
          })
          .catch((error: ActivateAuth) => {
            this.redirectToToAuthPage();
            reject(false);
          });
      }
    });
  }

  checkRouteAccess(activatedRoute) {
    let permission = activatedRoute.routeConfig.data && activatedRoute.routeConfig.data.permission;

    return permission ? this.authService.checkPermission(permission) : true;
  }

  redirectToChangePasswordPage(next) {
    if (next.routeConfig.path !== 'user/change_password') {
      this.router.navigate(this.changePasswordPage);
    }
  }

  redirectToPermissionDeniedPage(next, state) {
    if (next.routeConfig.path !== '/403') {
      this.router.navigate(this.accessDenied);
    }
  }

  redirectToMainPage() {
    this.router.navigate(this.mainPage);
  }

  redirectToToAuthPage() {
    this.router.navigate(this.authPage);
  }
}
